import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _StudentAnalysisReportCardPresenter;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import t from '@instructure/quiz-i18n/format-message';
import Card from '../../../../../common/components/shared/Card';
import { generateStyle } from './styles';
import { generateComponentTheme } from './theme';
import { ExportButton } from '../../common/ExportButton';
import Spinner from '../../../../../common/components/shared/spinner/Spinner';
import { Flex, STUDENT_ANALYSES, withStyleOverrides } from '@instructure/quiz-common';
import { AnalysisUpdateDate } from '../../common/AnalysisUpdateDate';
export var StudentAnalysisReportCardPresenter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_StudentAnalysisReportCardPresenter = /*#__PURE__*/function (_Component) {
  function StudentAnalysisReportCardPresenter() {
    var _this2;
    _classCallCheck(this, StudentAnalysisReportCardPresenter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, StudentAnalysisReportCardPresenter, [].concat(args));
    _defineProperty(_this2, "renderSpinner", function () {
      var mainText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return /*#__PURE__*/React.createElement("div", {
        style: _this2.props.styles.emptyCardBodyContainer
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "row"
      }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Spinner, {
        size: "x-small",
        color: "brand",
        minHeight: "0",
        mainText: mainText,
        fontSize: "x-small",
        "data-automation": "sdk-new-sa-report-card-spinner"
      }))));
    });
    _defineProperty(_this2, "getAttemptType", function () {
      return _this2.props.allAttemptsEnabled ? 'all_attempts' : 'last_attempt';
    });
    _defineProperty(_this2, "handleExport", function () {
      _this2.props.exportReport('csv', _this2.getAttemptType(), STUDENT_ANALYSES);
    });
    _defineProperty(_this2, "handleGeneration", function () {
      _this2.props.generateReport(_this2.getAttemptType(), STUDENT_ANALYSES);
    });
    _defineProperty(_this2, "renderExportButton", function () {
      var _this2$props = _this2.props,
        studentAnalyses = _this2$props.studentAnalyses,
        generationInProgress = _this2$props.generationInProgress;
      return /*#__PURE__*/React.createElement(ExportButton, {
        enabled: !generationInProgress && !!studentAnalyses,
        handleExport: _this2.handleExport
      });
    });
    _defineProperty(_this2, "renderGenerateReportButton", function () {
      return /*#__PURE__*/React.createElement(Link, {
        onClick: _this2.handleGeneration,
        role: "button",
        "data-automation": "sdk-new-sa-report-card-generate-report-button"
      }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Generate Student Analysis Report')), /*#__PURE__*/React.createElement(Text, {
        size: "small",
        "aria-hidden": "true"
      }, t('Generate Report')));
    });
    _defineProperty(_this2, "renderReportCardHeader", function () {
      var _this2$props2 = _this2.props,
        name = _this2$props2.name,
        exportEnabled = _this2$props2.exportEnabled,
        fetchInProgress = _this2$props2.fetchInProgress;
      return /*#__PURE__*/React.createElement("div", {
        style: _this2.props.styles.titleContainer
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "row",
        wrap: "wrap",
        justifyItems: "space-between"
      }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Text, {
        size: "medium",
        weight: "bold"
      }, name)), exportEnabled && !fetchInProgress && /*#__PURE__*/React.createElement(Flex.Item, null, _this2.renderExportButton())));
    });
    _defineProperty(_this2, "renderReportCardFooter", function () {
      var _this2$props3 = _this2.props,
        generationInProgress = _this2$props3.generationInProgress,
        analysisError = _this2$props3.analysisError;
      return /*#__PURE__*/React.createElement("div", {
        style: _this2.props.styles.emptyCardBodyContainer
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "row",
        justifyItems: "space-between"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        shouldShrink: true,
        size: analysisError && !generationInProgress ? '40%' : undefined
      }, analysisError && !generationInProgress && /*#__PURE__*/React.createElement(Text, {
        size: "x-small",
        weight: "bold",
        color: "danger"
      }, analysisError)), /*#__PURE__*/React.createElement(Flex.Item, {
        shouldShrink: !!analysisError && !generationInProgress
      }, generationInProgress ? _this2.renderSpinner(t('Generation In Progress')) : _this2.renderGenerateReportButton())));
    });
    _defineProperty(_this2, "renderDateBlock", function () {
      var studentAnalyses = _this2.props.studentAnalyses;
      return /*#__PURE__*/React.createElement("div", {
        style: _this2.props.styles.studentAnalysesSummary
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "row",
        justifyItems: "space-between"
      }, /*#__PURE__*/React.createElement("div", {
        style: _this2.props.styles.dateContainer
      }, /*#__PURE__*/React.createElement(AnalysisUpdateDate, {
        date: studentAnalyses.created_timestamp,
        multiline: true
      }))));
    });
    return _this2;
  }
  _inherits(StudentAnalysisReportCardPresenter, _Component);
  return _createClass(StudentAnalysisReportCardPresenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$makeStyle, _this$props;
      (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 || _this$props$makeStyle.call(_this$props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props$makeStyle2, _this$props2;
      (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 || _this$props$makeStyle2.call(_this$props2);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        studentAnalyses = _this$props3.studentAnalyses,
        fetchInProgress = _this$props3.fetchInProgress,
        styles = _this$props3.styles;
      return /*#__PURE__*/React.createElement(Card, {
        css: styles.reportCard,
        customStyles: styles.reportCard,
        wrapped: undefined,
        wrapperStyles: undefined
      }, this.renderReportCardHeader(), !fetchInProgress && studentAnalyses && this.renderDateBlock(), fetchInProgress && this.renderSpinner(), !fetchInProgress && this.renderReportCardFooter());
    }
  }]);
}(Component), _defineProperty(_StudentAnalysisReportCardPresenter, "displayName", 'StudentAnalysisReportCardPresenter'), _defineProperty(_StudentAnalysisReportCardPresenter, "componentId", "Quizzes".concat(_StudentAnalysisReportCardPresenter.displayName)), _defineProperty(_StudentAnalysisReportCardPresenter, "defaultProps", {
  studentAnalyses: void 0,
  analysisError: void 0,
  generationInProgress: void 0
}), _StudentAnalysisReportCardPresenter)) || _class);